import {useGetPurchaseV1CMQuery} from "../../core/api/clockmaker-analytical-data-api";
import Loading from "../../components/Common/Loading";
import {DataGrid} from "@mui/x-data-grid";
import { useState } from "react"

const columns = [

    {
        headerName: 'Timestamp',
        field: 'timestamp',
        flex: 1
    },
    {
        headerName: 'Category',
        field: 'category',
        flex: 1
    },
    {
        headerName: 'Category name',
        field: 'categoryName',
        flex: 1
    },
    {
        headerName: 'Source',
        field: 'source',
        flex: 1
    },
    {
        headerName: 'Items',
        field: 'items',
        flex: 1,
        renderCell: (params) => {
            if(params.row?.items == null) return <></>
            return <>{params.row?.items.split("\\n").map(item => <>{item}, </>)}</>
        },
    },
    {
        headerName: 'Payload',
        field: 'payload',
        flex: 1
    },
    {
        headerName: 'Action',
        field: 'action',
        flex: 1
    },

]

const PurchaseCM = (props) => {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100
    })

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetPurchaseV1CMQuery({
        "userId": props.deviceId,
        "depth": props.depth,
        "page": paginationModel.page,
        "limit": paginationModel.pageSize,
        "payload": props.payload ?? 0
    }, {
        skip: !props.deviceId || props.deviceId.trim() === ""
    })

    let payments = ""

    if (typeof data === "object") {

        payments = <DataGrid
            getRowId={(row) => row.id}
            rows={data}
            rowCount={-1}
            columns={columns}
            pagination={true}
            paginationMode="server"
            pageSizeOptions={[100]}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            autoHeight

        />
    } else {
        payments = "no data"
    }

    return (
        <Loading
            isLoading={isLoading||isFetching}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {payments}

        </Loading>
    )
}

export default PurchaseCM
